import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { getSiteConfig } from "@/lib/api";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_df2c336a-cf24-4860-adef-adda9eebb723/artifacts/c9aru5vi_Color%20Logo.png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [navLinks, setNavLinks] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    getSiteConfig("navbar").then(r => {
      const links = r.data?.data?.links || [];
      setNavLinks(links.filter(l => l.visible !== false).sort((a, b) => (a.order || 0) - (b.order || 0)));
    }).catch(() => {
      setNavLinks([
        { label: "Accueil", href: "/#hero" }, { label: "À propos", href: "/#about" },
        { label: "Recherche", href: "/#research" }, { label: "Projets", href: "/#projects" },
        { label: "Équipe", href: "/#team" }, { label: "Actualités", href: "/#news" },
        { label: "Blog", href: "/blog" }, { label: "Contact", href: "/#contact" },
      ]);
    });
  }, []);

  const handleNavClick = (href) => {
    setMobileOpen(false);
    if (href.startsWith("/#")) {
      if (location.pathname !== "/") { window.location.href = href; return; }
      const el = document.getElementById(href.replace("/#", ""));
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const isRouterLink = (href) => href.startsWith("/") && !href.startsWith("/#");

  return (
    <nav data-testid="main-navbar" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/90 backdrop-blur-xl shadow-sm border-b border-slate-200/50" : "bg-transparent"}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
          <img src={LOGO_URL} alt="UR-EBioReZ" className="h-10 md:h-12 w-auto" />
        </Link>
        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            isRouterLink(link.href) ? (
              <Link key={link.label} to={link.href} className={`text-sm font-medium transition-colors hover:text-[#1670B9] ${scrolled ? "text-slate-700" : "text-white"}`} data-testid={`nav-link-${link.label.toLowerCase()}`}>
                {link.label}
              </Link>
            ) : (
              <button key={link.label} onClick={() => handleNavClick(link.href)} className={`text-sm font-medium transition-colors hover:text-[#1670B9] ${scrolled ? "text-slate-700" : "text-white"}`} data-testid={`nav-link-${link.label.toLowerCase()}`}>
                {link.label}
              </button>
            )
          ))}
          <Link to="/admin/login" className="px-5 py-2 rounded-xl bg-[#F49C03] text-white text-sm font-semibold hover:bg-[#e08e00] transition-all hover:-translate-y-0.5 shadow-sm hover:shadow-md" data-testid="nav-admin-btn">Admin</Link>
        </div>
        <button className="lg:hidden p-2" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle">
          {mobileOpen ? <X className={scrolled ? "text-slate-800" : "text-white"} size={24} /> : <Menu className={scrolled ? "text-slate-800" : "text-white"} size={24} />}
        </button>
      </div>
      {mobileOpen && (
        <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-slate-100 shadow-lg" data-testid="mobile-nav-menu">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              isRouterLink(link.href) ? (
                <Link key={link.label} to={link.href} onClick={() => setMobileOpen(false)} className="block text-sm font-medium text-slate-700 hover:text-[#1670B9] py-2">{link.label}</Link>
              ) : (
                <button key={link.label} onClick={() => handleNavClick(link.href)} className="block w-full text-left text-sm font-medium text-slate-700 hover:text-[#1670B9] py-2">{link.label}</button>
              )
            ))}
            <Link to="/admin/login" onClick={() => setMobileOpen(false)} className="block text-center px-5 py-2 rounded-xl bg-[#F49C03] text-white text-sm font-semibold mt-2">Admin</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
